import { BorderedInput } from '@navi/web-ui/lib/primitives';
import { AddNumberProps } from './AddNewNumberOverlay';
import {
  Control,
  Controller,
  FieldErrorsImpl,
  RegisterOptions,
  UseFormGetValues
} from 'react-hook-form';

type IBorderedInputTextBoxProps = {
  placeholder: string;
  type: string;
  errors: Partial<FieldErrorsImpl<AddNumberProps>>;
  containerClassName?: string;
  RightInputAdornment?: React.ReactNode;
  control: Control<AddNumberProps, any>;
  name: keyof AddNumberProps;
  rules: RegisterOptions;
  isRequired?: boolean;
  maxLength?: number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};
const BorderedInputTextBox = (props: IBorderedInputTextBoxProps) => {
  const {
    placeholder,
    type,
    errors,
    containerClassName,
    RightInputAdornment,
    control,
    name,
    rules,
    maxLength,
    isRequired = true
  } = props;

  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value, ref } }) => (
          <BorderedInput
            placeholder={placeholder}
            ref={ref}
            type={type}
            fullWidth={true}
            required={isRequired}
            containerClassName={containerClassName}
            value={value}
            onChange={e => {
              onChange(e.target.value);
            }}
            maxLength={maxLength}
            error={errors && errors[name] && errors[name].message}
            RightInputAdornment={RightInputAdornment}
            onFocus={e => e}
          />
        )}
      />
    </>
  );
};

export default BorderedInputTextBox;
